import React from 'react';

export default function LoadingFront() {
    return (
        <div className="flex items-center justify-center space-x-2 bg-white min-h-36 dark:invert">
            <span className="sr-only">Loading...</span>
            <div className="h-4 w-4 bg-main-color rounded-full animate-bounce [animation-delay:-0.3s]"></div>
            <div className="h-4 w-4 bg-main-color rounded-full animate-bounce [animation-delay:-0.15s]"></div>
            <div className="w-4 h-4 rounded-full bg-main-color animate-bounce"></div>
        </div>
    );
}
